module.exports = __webpack_public_path__ + "img/文书分类.b9b32744.png";